import { IsNotEmpty, IsUUID } from 'class-validator';

export class GetStaffPosititionEmployees {
  @IsUUID()
  @IsNotEmpty()
  eventId: string;

  @IsUUID()
  @IsNotEmpty()
  staffPositionId: string;
}
